import type { BuildRegistryParams } from '../interfaces'

import { getConsumerFeedPrefix } from './getConsumerFeedPrefix'
import { normalizeGuidTier } from './normalizeGuidTier'

const trimSlashes = (value: string): string => value.trim().replace(/^\/+|\/+$/g, '')

export const buildRegistry = ({
  selectedTechnology,
  gsmuEndpoint,
  registryPath,
  guid,
}: BuildRegistryParams): string => {
  if (!selectedTechnology?.trim()) {
    throw new Error('selectedTechnology is required to build registry URL')
  }

  const base = trimSlashes(gsmuEndpoint)
  const path = trimSlashes(registryPath)
  const tier = normalizeGuidTier(guid)
  const consumerPrefix = getConsumerFeedPrefix(selectedTechnology)

  if (!base) {
    throw new Error('gsmuEndpoint is required')
  }

  if (!path) {
    throw new Error('registry path is required')
  }

  return `${base}${consumerPrefix}/${path}${tier}`
}
